<template>
  <div>&nbsp;</div>
  <div class="row">
    <div class="col-sm-12">
      <div class="instant modspec_title-small">Summary</div>
    </div>
  </div>

  <div v-if="!wasCalculated" class="row mt-3 mb-3">
    <div class="col-sm-12 text-start">
      <h5 class="modspec_font14">
        Fill out the adjacent inputs to generate a price.
      </h5>      
      <h6 class="modspec_font12" style="font-style: italic !important; font-weight: bold !important;">
        **Map data must fully load before pricing can be generated. If no climate zone is detected, wait a moment and re-enter the address.
      </h6>
    </div>
  </div>

  <div v-else>
    <div class="row mt-3 mb-3">
      <div class="col-sm-12 text-start">
        {{ method.Name }}
        <hr />
      </div>
    </div>

    <div id="dvResume">
      <div class="row">
        <div class="col-sm-12"><b>Buildings:</b> {{ getNumBuildings }} {{ getNumBuildingName }}</div>
      </div>
      <div class="row">
        <div class="col-sm-12"><b>Orientations:</b> {{ getNumOrientation }}</div>
      </div>
      <div class="row" v-if="getNumWeatherFiles > 0">
        <div class="col-sm-12"><b>Weather Files:</b> {{ getNumWeatherFiles }} </div>
      </div>
      <div class="row">
        <div class="col-sm-12"><b>Climate Zones:</b> {{ getClimateZones }}</div>
      </div>
      <div class="row">
        <div class="col-sm-12"><b>Construction Option:</b> As per drawings</div>
      </div>
      <div class="row">
        <div class="col-sm-12"><b>Glazing template:</b> As per drawings</div>
      </div>
      <br>
      <div v-if="isJVorDTS">
        <div class="row mt-2">
          <div class="col-sm-12">
            {{ resume.text }}
          </div>
        </div>

        <div class="row mt-2" v-if="resume.data.IncludeAssessment.isIA">
          <div class="col-sm-12">
            <p><i class="bi bi bi-plus modspec_font12"></i> {{ resume.data.IncludeAssessment.text }}</p>
          </div>
        </div>

        <div v-if="isMultipleBuildings">
          <div v-for="(resum, name) in resume.textBuildings" :key="name">
            <div class="row mt-3">
              <div class="col-sm-12">{{ resum.name }}</div>
            </div>
            <div class="row">
              <div class="offset-sm-1 col-sm-7">{{ resum.orientation }}</div>
              <div class="col-sm-4">
                <span v-if="resum.discount > 0" style="text-decoration: line-through;">${{ resum.crude }}</span> ${{
                  resum.amounts }}
                <span class="modspec_font10" v-if="resum.percentDiscount == 15">*</span>
                <span class="modspec_font10" v-if="resum.percentDiscount == 35">**</span>
                <span class="modspec_font10" v-if="resum.percentDiscount == 50">***</span>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-sm-12 modspec_font10">* Discount applied 15%</div>
            <div class="col-sm-12 modspec_font10">** Discount applied 35%</div>
            <div class="col-sm-12 modspec_font10">*** Discount applied 50%</div>
          </div>

        </div>

        <div v-if="this.quote.Buildings.length == 1" class="row mt-3">
          <div class="col-sm-12"><b>Applied Discount ({{ resume.textBuildings[0].percentDiscount }}%)</b></div>
          <div v-if="resume.textBuildings[0].percentDiscount == 15 || resume.textBuildings[0].percentDiscount == 50"
            class="col-sm-12">15% discount applied: same building design as previously assessed</div>
          <div v-if="resume.textBuildings[0].percentDiscount == 35 || resume.textBuildings[0].percentDiscount == 50"
            class="col-sm-12">35% discount applied: same construction as previous job</div>
        </div>
      </div>

    </div>



    <div class="row" v-if="seeDiscount">
      <div class="col-sm-12">
        <h5 class="modspec_font10-600">Applied Discount {25%}</h5>
        <p class="modspec_font10">
          10% discount applied: same construction as previous job: roof
        </p>
        <p class="modspec_font10">
          15% discount applied: same building design as previously assessed
        </p>
      </div>
    </div>

    <div class="row mt-5" v-if="!isJVorDTS">
      <div class="col-sm-12">
        <a href="#" class="link14 modspec_font14-600" @click="seePricing($event)">See Pricing Breakdown</a>
        >
        <img src="@/assets/images/dropdown.png" />
      </div>
    </div>

    <div class="stages" v-if="!isJVorDTS && seePricingBreakdown">
      <div class="stages stage1 mt-5">
        <div class="accordion-item">
          <div class="accordion-header" id="accordionHeaderStage1">
            <div class="row">
              <div class="col-sm-10">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#accordionStage1" aria-expanded="true" aria-controls="accordionStage1">
                  <i class="bi bi-caret-down"></i>
                  <span class="modspec_font10-600">Stage 1: Initial JV3 Research</span>
                </button>
              </div>
              <div class="col-sm-2 modspec_font10-600">
                ${{ getPriceStage1 }}
              </div>
            </div>
          </div>
          <div id="accordionStage1" class="accordion-collapse collapse" aria-labelledby="headingOne"
            data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Weather File Review - {{ getClimateZones }} climate zones
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Drawing Review - {{ getReference }} select builds
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Modelling - {{ getReference }} select builds
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  {{ getNumSimulation }}x Simulation Batch - sample JV3 results
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  {{ getNumSimulation2 }}x Simulation Batch - sample thermal
                  comfort results
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Data Analysis + Summary Email
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">Project Management</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="stages stage2 mt-3">
        <div class="accordion-item">
          <div class="accordion-header" id="accordionHeaderStage2">
            <div class="row">
              <div class="col-sm-10">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#accordionStage2" aria-expanded="true" aria-controls="accordionStage2">
                  <i class="bi bi-caret-down"></i>
                  <span class="modspec_font10-600">Stage 2: Improvements</span>
                </button>
              </div>
              <div class="col-sm-2 modspec_font10-600">
                ${{ getPriceStage2 }}
              </div>
            </div>
          </div>
          <div id="accordionStage2" class="accordion-collapse collapse" aria-labelledby="accordionHeaderStage2"
            data-bs-parent="#accordionHeaderStage2">
            <div class="accordion-body">
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Review & Improvements to establish final building
                  specification:<br />
                  20 Consulting hours included - Subject to variation
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Building Airtightness Testing Fee N/A
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="stages stage3 mt-3">
        <div class="accordion-item">
          <div class="accordion-header" id="accordionHeaderStage3">
            <div class="row">
              <div class="col-sm-10">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#accordionStage3" aria-expanded="true" aria-controls="accordionStage3">
                  <i class="bi bi-caret-down"></i>
                  <span class="modspec_font10-600">Stage 3: JV3 Conclusive Assessment</span>
                </button>
              </div>
              <div class="col-sm-2 modspec_font10-600">
                ${{ getPriceStage3 }}
              </div>
            </div>
          </div>
          <div id="accordionStage3" class="accordion-collapse collapse" aria-labelledby="accordionHeaderStage3"
            data-bs-parent="#accordionHeaderStage3">
            <div class="accordion-body">
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Drawing Review -
                  {{ getNumBuildings - getReference }} remaining builds
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Modelling - {{ getNumBuildings - getReference }} remaining
                  builds
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  {{
                    getNumBuildings *
                    getNumWeatherFiles *
                    getNumOrientation *
                    2
                  }}x Simulation Batch - final JV3 results
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  {{ getNumWeatherFiles * getNumBuildings }}x Simulation Batch -
                  final thermal comfort results"
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Data Analysis + Summary Email
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 modspec_font10">Project Management</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="stages stage4 mt-3">
        <div class="accordion-item">
          <div class="accordion-header" id="accordionHeaderStage4">
            <div class="row">
              <div class="col-sm-10">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                  data-bs-target="#accordionStage4" aria-expanded="true" aria-controls="accordionStage4">
                  <i class="bi bi-caret-down"></i>
                  <span class="modspec_font10-600">Stage 4: Reporting</span>
                </button>
              </div>
              <div class="col-sm-2 modspec_font10-600">
                ${{ getPriceStage4 }}
              </div>
            </div>
          </div>
          <div id="accordionStage4" class="accordion-collapse collapse" aria-labelledby="accordionHeaderStage4"
            data-bs-parent="#accordionHeaderStage4">
            <div class="accordion-body">
              <div class="row">
                <div class="col-sm-12 modspec_font10">
                  Custom Research Report(s) - Generic
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modspec_font10 mt-5" v-if="!isJVorDTS">
        <div class="row">
          <div class="col-sm-12">
            <span class="modspec_font10-600">Cost Comparison</span>
            <span>(Standard Compliance)</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <p class="text-justify">
              This assessment offers the equivalent of
              <strong>${{ (getJV3NumSimulation / 2) * 1000 }}</strong> value if compared to site-specific JV3/J1V3
              assessment reports being administered to generate the same simultation output.
              This means the handbook will save <strong>${{ saveCost }}</strong> in compliance assessment costs,
              with the conservative estimate that traditional JV3/J1V3 assessments are costing on average $1000 each.
              You will need to use this handbook for development applications on <strong>{{ getUnitsToBuild }}</strong>
              projects using
              any of the assessed generic designs if you intend to offset the upfront cost of this assessment and
              effectively reduce
              overall Section J compliance costs. In additional to compliance cost savings,
              Section J handbooks can result in significant production cost savings by replacing DTS requirements with
              performance based
              compliance solutions, whilst increasing workflow efficiency by replacing project-to-project compliance
              coordination with a
              single report that can be used for numerous projects.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div v-if="!isLeadTime" class="col-sm-12">
        <p>Standard assessment lead time for this project is {{ getDaysForLeadTime }} business days</p>
      </div>
      <div class="col-sm-12" v-if="permitULT">
        <input class="form-check-input" type="checkbox" name="chkLeadTime" v-model="isLeadTime" id="chkLeadTime" />
        <label class="form-check-label modspec_font12" for="chkLeadTime"> Urgent lead time. Request immediate start
          <i @click="showInformationIUL()" style="position: absolute; margin-top: -5px; cursor: pointer;"
            class="bi bi bi-info-circle me-1 modspec_font8" title="Lead Time"></i>
        </label>
      </div>
      <div v-if="isLeadTime" class="col-sm-12">
        <p>{{ ULT.percent }}% premium: + ${{ ULT.total }}</p>
      </div>
    </div>

    <div v-if="!permitULT" class="row mt-5">
      <div class="col-sm-12">
        <p>If you need your project quicker, please contact us</p>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-sm-12 modspec_font10">
        <strong>Item Subtotal:</strong> {Excluding GST}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="price modspec_font16-600">
          <div class="row">
            <div v-if="getDiscount > 0" class="col-sm-6 text-end">
              <span v-if="getDiscount > 0" style="color:#838385;text-decoration: line-through;">${{ getCrudeValue
              }}</span>
            </div>
            <div class="col-sm">${{ getPrice }}</div>
          </div>

        </div>
      </div>
    </div>
  </div>



</template>
<script>
import data from "../../helpers/data.json";

export default {
  name: "sum-ary",
  props: ["quote", "method"],
  components: {
  },
  data: function () {
    return {
      seeDiscount: false,
      seePricingBreakdown: false,
      resumen: "",
      isLeadTime: false
    };
  },
  mounted() {
    //this.setResume();
  },
  watch: {
    resume(newr, old) {
      console.log(old);
      this.$emit('setResume', JSON.stringify(newr));
    },
    isLeadTime(n, o) {
      console.log(this.isLeadTime, n, o)
      this.$emit('setLeadTime', this.isLeadTime);
    },
    method(n, o) {
      if (n != o) {
        this.isLeadTime = false
      }
    }
  },
  methods: {
    seePricing(e) {
      e.preventDefault();
      if (this.seePricingBreakdown) {
        this.seePricingBreakdown = false;
      } else {
        this.seePricingBreakdown = true;
      }
    },
    getClassName(classId) {
      return data.construction.find(c => c.value == classId)?.short_name || ''
    },
    /*setLeadTime() {
      this.isLeadTime = !this.isLeadTime;
      this.$emit('setLeadTime', this.isLeadTime);
    },*/
    showInformationIUL() {
      document.getElementById('btnOpenInfoUrgentLead').click();
    },
  },
  computed: {
    isMultipleBuildings() {
      return this.quote.Buildings.length > 1;
    },
    ULT() {
      let u = { isULT: this.isLeadTime, percent: this.quote.DataCalc.percentUrgentIncrementTime, total: this.quote.DataCalc.totalUrgentIncrementTime }
      return u;
    },
    permitULT() {
      return this.quote.DataCalc.permitULT
    },
    resume() {
      let r = "";
      let self = this;
      let theResume = { text: '', name: '', data: {}, textBuildings: [] };
      let theName = '';

      if (this.quote != null) {

        if (this.isV2) {
          let nameMethod = "NCC 2019 VURB (V2.6.2.2)";
          let addName = "P2.6.1";
          if (this.isJustH6V2) {
            nameMethod = "H6V2 (NCC22)";
            addName = "H6P1";
          }

          if (this.quote.Buildings.length == 1) {
            let tBuild = this.quote.Buildings[0];

            r = `${nameMethod} Verification Using a Reference `;
            r += `Building assessment (${tBuild.Name}) - ${tBuild.NumOrientations > 1 ? 'Multi' : 'Single'}-orientation (${tBuild.Orientations}) `;
            r += `analysis & assessment of Building for compliance with ${addName} `;
            r += `for the class ${self.getClassName(tBuild.BuildingClass)}, ${tBuild.Area == '' ? tBuild.NumModules + ' modules' : tBuild.Area + 'm2'} - ${tBuild.Name} building located next to ${this.getWeatherFileName} `;
            r += `weather station, Climate Zone ${this.getClimateZoneName}. `;
          }
          else {
            r = `${nameMethod} Verification Using a Reference Building assessment, analysis & assessment of buildings listed below for compliance with ${addName}, located next to ${this.getWeatherFileName} weather station, Climate Zone ${this.getClimateZoneName}.`;
          }
          theName = nameMethod;
        }
        else {
          r = `${this.method.Name} - `;
          if (this.quote.Buildings.length == 1) {
            r += `${this.getNumBuildingName} - ${this.orientationType}-Orientation `;
          }

          let jts = { one: 'J4', two: 'J5' };
          if (this.method.Id == 1 || this.method.Id == 3) {
            jts.one = 'J1';
            jts.two = 'J3';
          }
          r += `Compliance Assessment of Building fabric (Part ${jts.one}) and Building sealing (Part ${jts.two}) for the `;
          if (this.quote.Buildings.length == 1) {
            r += `class ${this.getClass}, ${this.getNumBuildingsModules} building, `;
          }
          else {
            r += `buildings listed below `;
          }

          if (this.isDTS) {
            r += `located in Climate Zone(s) ${this.getClimateZoneName}.`;
          } else {
            r += `located next to ${this.getWeatherFileName} Weather Station.`;
          }
          theName = `${this.method.Name}`
        }


        if (this.isJVorDTS) {

          this.quote.Buildings.forEach(function (b, index) {
            let bld = {
              name: `${b.Area == '' ? b.NumModules + ' modules' : b.Area + 'm2'} - ${b.Name}`,
              orientation: `${b.NumOrientations > 1 ? 'Multi' : 'Single'}-Orientation (${b.Orientations}), class ${self.getClassName(b.BuildingClass)}`,
              amounts: self.quote.DataCalc.buildingsValue[index],
              crude: self.quote.DataCalc.buildingsCrudeValue[index],
              discount: self.quote.DataCalc.discountsValue[index],
              percentDiscount: self.quote.DataCalc.percentValue[index],
            };
            theResume.textBuildings.push(bld);
          });

        }

        if (this.quote.Address) {
          theName = theName + ' - ' + this.quote.Address.split(',')[0].trim()
        } else {
          theName = `${theName} - Zones: ${this.getClimateZoneName}`;
        }

        theResume.name = theName;
        theResume.text = r;
        theResume.data.Total = this.getPrice;
        if (this.$vtc.isHB(this.method.Id)) {
          theResume.data.ClimateZones = this.getClimateZones;
          theResume.data.Reference = this.getReference;
          theResume.data.NumSimulation = this.getNumSimulation;
          theResume.data.NumSimulation2 = this.getNumSimulation2;
          theResume.data.PriceStage1 = this.getPriceStage1;
          theResume.data.PriceStage2 = this.getPriceStage2;

          theResume.data.DrawingReview = this.getNumBuildings - this.getReference;
          theResume.data.Modelling = this.getNumBuildings - this.getReference;
          theResume.data.SimulationBatchJV3 = this.getNumBuildings * this.getNumWeatherFiles * this.getNumOrientation * 2;
          theResume.data.SimulationBatchFinal = this.getNumWeatherFiles * this.getNumBuildings;

          theResume.data.PriceStage3 = this.getPriceStage3;
          theResume.data.PriceStage4 = this.getPriceStage4;
        }

        theResume.data.IncludeAssessment = this.getIncludeAssessment
        theResume.data.ULT = this.ULT;

      }

      return theResume;
    },
    saveCost() {
      let v = (this.getJV3NumSimulation / 2) * 1000;
      return (
        v -
        (this.getPriceStage1 +
          this.getPriceStage2 +
          this.getPriceStage3 +
          this.getPriceStage4)
      );
    },
    getDaysForLeadTime() {
      let text = ''
      switch (true) {
        case (this.quote.Price <= 1500):
          text = '3 - 5';
          break;
        case (this.quote.Price > 1500 && this.quote.Price <= 2000):
          text = '4 - 6';
          break;
        case (this.quote.Price > 2000 && this.quote.Price <= 3000):
          text = '5 - 7';
          break;
        case (this.quote.Price > 3000 && this.quote.Price <= 5000):
          text = '5 - 8';
          break;
        case (this.quote.Price > 5000 && this.quote.Price <= 7500):
          text = '7 - 10';
          break;
        case (this.quote.Price > 7500 && this.quote.Price <= 10000):
          text = '8 - 12';
          break;
        case (this.quote.Price > 10000):
          text = '12 - 15';
          break;
      }
      return text;
    },
    wasCalculated() {
      return this.quote != null;
    },
    getDiscount() {
      return this.quote.DataCalc.totalDiscount;
    },
    getCrudeValue() {
      return this.quote.DataCalc.totalCrudeValue;
    },
    getPrice() {
      return this.quote.Price;
    },
    getPriceStage1() {
      return this.quote.DataCalc.buildingsValue[0];
    },
    getPriceStage2() {
      return this.quote.DataCalc.buildingsValue[1];
    },
    getPriceStage3() {
      return this.quote.DataCalc.buildingsValue[2];
    },
    getPriceStage4() {
      return this.quote.DataCalc.buildingsValue[3];
    },
    getReference() {
      if (this.quote != null) {
        return this.quote.NumBuildings <= 4 ? 1 : 2;
      }
      return 0;
    },
    getVariableMultiplier() {
      return 1;
    },
    getClimateZones() {
      if (this.quote != null) {
        return this.quote.NumClimateZones;
      }
      return 0;
    },
    getNumBuildings() {
      if (this.quote != null) {
        return this.quote.NumBuildings;
      }
      return 0;
    },

    getNumBuildingName() {
      if (this.quote != null) {
        return this.quote.NumBuildingsName != '' ? `(${this.quote.NumBuildingsName})` : '';
      }
      return ''
    },

    getNumBuildingsModules() {
      if (this.quote != null) {
        if (this.quote.NumBuildingsModules == 0) {
          return this.quote.NumBuildingsArea + "m2";
        } else {
          return this.quote.NumBuildingsModules + " module";
        }
      }
      return "";
    },
    orientationType() {
      if (this.quote != null) {
        return this.getNumOrientation > 1 ? 'Multi' : 'Single'
      }
      return 'Single';
    },
    getNumOrientation() {
      if (this.quote != null) {
        if (this.isJVorDTS) {

          if (this.quote.Buildings.length == 1) {
            let b = this.quote.Buildings[0];
            return b.NumOrientations;
          }
          else {
            let n = 0;
            this.quote.Buildings.forEach(function (b) {
              n += b.NumOrientations;
            });
            return n;
          }

        } else {
          return this.quote.NumOrientations;
        }

      }
      return 0;
    },
    getNumWeatherFiles() {
      if (this.quote != null) {
        return this.quote.NumWeatherFiles;
      }
      return 0;
    },
    getWeatherFileName() {
      if (this.quote != null) {
        return this.quote.WeatherFileName;
      }
      return 0;
    },
    getClimateZoneName() {
      if (this.quote != null) {
        return this.quote.ClimateZoneName;
      }
      return 0;
    },
    getNumSimulation() {
      let num = this.quote.NumOrientations;
      return (
        num *
        2 *
        this.quote.NumClimateZones *
        this.getReference *
        this.getVariableMultiplier
      );
    },
    getNumSimulation2() {
      let num =
        this.quote.NumClimateZones *
        this.getReference *
        this.getVariableMultiplier;
      return num;
    },
    getJV3NumSimulation() {
      return (
        this.quote.NumBuildings *
        this.quote.NumWeatherFiles *
        this.quote.NumOrientations *
        2
      );
    },
    getIncludeAssessment() {
      return { isIA: this.quote.IncludeAssessments, text: this.getIncludeAssessmentsText, total: this.quote.DataCalc.totalIncludeAssisment }

    },
    getIncludeAssessmentsText() {
      let r = "";

      if (this.quote.IncludeAssessments) {
        if (this.isJustV2622) {
          r = "Services (Part 3.12.5) for compliance with P2.6.2";
        }
        else if (this.isJustH6V2) {
          r = "Whole-of-Home Energy Usage (Part 13.6), and Services (Part 13.7) for compliance with H6P2 Energy Usage";
        }
        else if (this.isNCC2019) {
          r = "Artificial lighting & power (Part J6), Heated water supply & swimming pool & spa pool plant (Part J7), Facilities for energy monitoring (Part J8)"
        }
        else {
          r = "Interior artificial lighting & power control (Part J7), Heated water supply and swimming pool and spa pool plant (Part J8), Energy Monitoring and on-site distributed energy resources (Part J9)"
        }
      }
      return r
    },
    getUnitsToBuild() {
      return (this.quote.Price / 1500).toFixed(0);
    },
    isJVorDTS() {
      return this.$vtc.isJVorDTS(this.method.Id);
    },
    getClass() {
      if (this.quote != null) {
        return this.quote.className;
      }
      return ''
    },
    isDTS() {
      return this.$vtc.isDTS(this.method.Id);
    },
    isV2() {
      return this.$vtc.isV2(this.method.Id);
    },
    isJustH6V2() {
      return this.$vtc.isJustH6V2(this.method.Id);
    },
    isJustV2622() {
      return this.$vtc.isJustV2622(this.method.Id);
    },
    isHB() {
      return this.$vtc.isHB(this.method.Id);
    },
    isNCC2019() {
      return this.$vtc.isNCC2019(this.method.Id);
    },
  },

};
</script>
<style scoped>
.instant {
  background-color: #232527;
  color: white;
  padding: 5px 5px 5px 5px;
}

.price {
  background-color: black;
  color: white;
  width: auto;
  position: relative;
  float: left;
  min-width: 250px;
  text-align: center;
  padding: 5px 5px 5px 5px;
}
</style>
